export default "__VITE_ASSET__OxyhFnsm__"